import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Container, Row, Col, Form } from 'react-bootstrap';
import './CRUDTouchs.css';
import { Server_URL } from "../config.js";

function EditTouch() {
  const [data, setData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  // console.log("get into EditTouch() id : ", id);

  useEffect(() => {
    axios
      .get(`${Server_URL}/get_touch/${id}`)
      // .get(`http://localhost:3022/get_touch/${id}`)
      // .get(`http://localhost:5000/get_touch/${id}`)
      .then((res) => { setData(res.data); })
      .catch((err) => console.log(err));
  }, [id]);

  function handleSubmit(e) {
    e.preventDefault();
    axios
      .post(`${Server_URL}/edit_touch/${id}`, data[0])
      // .post(`http://localhost:3022/edit_touch/${id}`, data[0])
      // .post(`http://localhost:5000/edit_touch/${id}`, data[0])
      .then((res) => { navigate(-1); })
      // .then((res) => { navigate("/CRUDTouchs"); })
      // .then((res) => { navigate("/"); console.log(res); })
      .catch((err) => console.log(err));
  }

  return (
    <div className='container container-fluid vw-100 bg-primary-subtle'>
    {/* <div className='container container-fluid vh-100 vw-100 bg-primary-subtle'> */}
      <Container>
        <Row>
          <div className='d-flex justify-content-center'> <h2>Edit Touch Panel SNo: {id}</h2> </div>
        </Row>
        <Row>
          <Col className='justify-content-start'>
            <button className='btn btn-success' onClick={() => navigate(-1)}>Back</button>
          </Col>
        </Row>
      </Container>
      <Container className='container-fluid'> {
        data.map((touch, i) => {
          // <Container className='container-fluid vh-100 vw-100 bg-primary-subtle'>
          return (
            <Form onSubmit={handleSubmit} key={i++}>
              <Container>
                <br />
                <Row>
                  <Col className='col-md-3'>
                    <label htmlFor="SNo"><b>SNo : </b></label>
                    <input value={touch.SNo} required
                      type="number" onChange={(e) => setData([{ ...data[0], SNo: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="Size"><b>Size : </b></label>
                    <input value={touch.Size} required
                      type="text25" onChange={(e) => setData([{ ...data[0], Size: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="PartNo"><b>PartNo : </b></label>
                    <input value={touch.PartNo} required
                      type="text75" onChange={(e) => setData([{ ...data[0], PartNo: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="Ratio"><b>Ratio : </b></label>
                    <input value={touch.Ratio}
                      type="text25" onChange={(e) => setData([{ ...data[0], Ratio: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-3'>
                    <label htmlFor="CoverOD"><b>CoverOD : </b></label>
                    <input value={touch.CoverOD}
                      type="text65" onChange={(e) => setData([{ ...data[0], CoverOD: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="LcmAA"><b>LcmAA : </b></label>
                    <input value={touch.LcmAA} required
                      type="text65" onChange={(e) => setData([{ ...data[0], LcmAA: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="CoverVA"><b>CoverVA : </b></label>
                    <input value={touch.CoverVA}
                      type="text65" onChange={(e) => setData([{ ...data[0], CoverVA: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="CoverThick"><b>CoverThick : </b></label>
                    <input value={touch.CoverThick}
                      type="text25" onChange={(e) => setData([{ ...data[0], CoverThick: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-3'>
                    <label htmlFor="SensorOD"><b>SensorOD : </b></label>
                    <input value={touch.SensorOD}
                      type="text65" onChange={(e) => setData([{ ...data[0], SensorOD: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="SensorAA"><b>SensorAA : </b></label>
                    <input value={touch.SensorAA}
                      type="text65" onChange={(e) => setData([{ ...data[0], SensorAA: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="SensorThick"><b>SensorThick : </b></label>
                    <input value={touch.SensorThick}
                      type="text25" onChange={(e) => setData([{ ...data[0], SensorThick: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-6'>
                    <label htmlFor="ChannelRxTx"><b>ChannelRxTx : </b></label>
                    <input value={touch.ChannelRxTx}
                      type="text75" onChange={(e) => setData([{ ...data[0], ChannelRxTx: e.target.value }])} />
                  </Col>
                  <Col className='col-md-6'>
                    <label htmlFor="ControlIC"><b>ControlCard/IC: </b></label>
                    <input value={touch.ControlIC}
                      type="text75" onChange={(e) => setData([{ ...data[0], ControlIC: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-3'>
                    <label htmlFor="CGParam"><b>CGParam : </b></label>
                    <input value={touch.CGParam}
                      type="text65" onChange={(e) => setData([{ ...data[0], CGParam: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="CustomerPN"><b>CustomerPN : </b></label>
                    <input value={touch.CustomerPN}
                      type="text50" onChange={(e) => setData([{ ...data[0], CustomerPN: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="SensorPN"><b>SensorPN : </b></label>
                    <input value={touch.SensorPN}
                      type="text50" onChange={(e) => setData([{ ...data[0], SensorPN: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-6'>
                    <label htmlFor="ConnectorType"><b>ConnectorType : </b></label>
                    <input value={touch.ConnectorType}
                      type="text75" onChange={(e) => setData([{ ...data[0], ConnectorType: e.target.value }])} />
                  </Col>
                  <Col className='col-md-6'>
                    <label htmlFor="FpcType"><b>FpcType : </b></label>
                    <input value={touch.FpcType}
                      type="text75" onChange={(e) => setData([{ ...data[0], FpcType: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-3'>
                    <label htmlFor="FWConfig"><b>FWConfig : </b></label>
                    <input value={touch.FWConfig}
                      type="text50" onChange={(e) => setData([{ ...data[0], FWConfig: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="FWDownload"><b>FWDownload : </b></label>
                    <input value={touch.FWDownload}
                      type="text50" onChange={(e) => setData([{ ...data[0], FWDownload: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="FWUpgrade"><b>FWUpgrade : </b></label>
                    <input value={touch.FWUpgrade}
                      type="text50" onChange={(e) => setData([{ ...data[0], FWUpgrade: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="FWVersion"><b>FWVersion : </b></label>
                    <input value={touch.FWVersion}
                      type="text50" onChange={(e) => setData([{ ...data[0], FWVersion: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-3'>
                    <label htmlFor="Resolution"><b>Resolution : </b></label>
                    <input value={touch.Resolution}
                      type="text50" onChange={(e) => setData([{ ...data[0], Resolution: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="Originaln"><b>Original : </b></label>
                    <input value={touch.Original}
                      type="text50" nChange={(e) => setData([{ ...data[0], Original: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="TestBoardn"><b>TestBoard : </b></label>
                    <input value={touch.TestBoard}
                      type="text50" onChange={(e) => setData([{ ...data[0], TestBoard: e.target.value }])} />
                  </Col>
                  <Col className='col-md-3'>
                    <label htmlFor="TestDate"><b>TestDate : </b></label>
                    <input value={touch.TestDate}
                      type="text50" onChange={(e) => setData([{ ...data[0], TestDate: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-md-3'>
                    <label htmlFor="RegistDate"><b>RegistDate : </b></label>
                    <input value={touch.RegistDate}
                      type="text50" onChange={(e) => setData([{ ...data[0], RegistDate: e.target.value }])} />
                  </Col>
                  <Col className='col-md-6'>
                    <label htmlFor="Note"><b>Note : </b></label>
                    <input value={touch.Note}
                      type="text75" onChange={(e) => setData([{ ...data[0], Note: e.target.value }])} />
                  </Col>
                  <Col className='col-md-6'>
                    <label htmlFor="DrawYes"><b>DrawYes : </b></label>
                    <input value={touch.DrawYes}
                      type="text75" onChange={(e) => setData([{ ...data[0], DrawYes: e.target.value }])} />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col className='col-sm d-flex justify-content-start'>
                    <button type='submit' className='btn btn-success'>Save</button>
                  </Col>
                </Row>
              </Container>
            </Form>
          );
        })
      } </Container>
    </div >
  )
}

export default EditTouch;